/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateTimePeriod } from './date-time-period';


export interface WorkerExportRequest { 
    datePeriod?: DateTimePeriod;
    reportDate?: string | null;
    keyword?: string | null;
    poolIds?: Array<string> | null;
    coinIds?: Array<number> | null;
    statusIds?: Array<number> | null;
}

